<mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <input type="text" 
        #input
        matInput [(ngModel)]="value" 
        readonly
        (click)="copy()"
        />
        
        <button matSuffix mat-icon-button (click)="copy()">
            <mat-icon>content_copy</mat-icon>
        </button>
</mat-form-field>